import React, { Component, useMemo } from 'react';
import Table from "../../../../../components/UI/Table/Table";
import { Row } from 'reactstrap';


class ViewLegalCases extends Component {

    tableColumns = [
        {
            Header: "Invalid ?",
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index)} />
                </label>
        },
        {
            Header: "Court",
            id: 'court',
            accessor: 'court_name'
        },
        {
            Header: 'Year',
            id: 'year',
            accessor: 'case_year'
        },
        {
            Header: 'Petitioner Name',
            id: 'petitioner',
            accessor: 'petitioner'
        },
        {
            Header: 'Respondent Name',
            id: 'respondent',
            accessor: 'respondent'
        },
        {
            Header: 'Act',
            id: 'act',
            accessor: 'acts'
        },
        {
            Header: 'Link',
            id: 'link',
            accessor: p => <a href={p.case_url} target="_blank" rel="noreferrer" > Click </a>
        }
    ];

    render() {
        return (
            <Table
                data={this.props.tasks}
                columns={this.tableColumns}
                defaultPageSize={10}
                className="CreateCaseModalTable highlight"
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                noDataText="No Cases found"
            />
        )
    }
}

export default ViewLegalCases;
